import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules'; 
import 'swiper/swiper-bundle.css';
import 'swiper/css'; 
import 'swiper/css/navigation'; 
import 'swiper/css/pagination'; 

const Carousel = ({ tasks = [] }) => {
  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1} 
      navigation  
      pagination={{ clickable: true }} 
     
      modules={[Navigation, Pagination]} 
    >
      {tasks.length > 0 ? (
        tasks.map(task => (
          <SwiperSlide key={task.id}>
            <div className="task-slide">
              <h3>{task.title}</h3>
              <p>{task.description}</p>
            </div>
          </SwiperSlide>
        ))
      ) : (
        <SwiperSlide>
          <div className="task-slide">
            <h3>No Tasks Available</h3>
            <p>Please add some tasks.</p>
          </div>
        </SwiperSlide>
      )}
    </Swiper>
  );
};

export default Carousel;